import { getEntityReview, listTickets } from './api/api.pleased';

const RECENT_REQUEST_INTERVAL = 1000 * 60 * 60 * 24 * 7;

export async function getRecentResolvedTicket(requesterId?: number | string) {
  if (!requesterId) {
    return { ticket: null, review: null };
  }

  const response = await listTickets({
    requesterId,
    limit: 1,
    offset: 0,
    updatedAtGreaterThan: new Date(Date.now() - RECENT_REQUEST_INTERVAL).toISOString(),
    status: 'RESOLVED',
    sortBy: 'UPDATED_AT',
  });

  const ticket = response.data.length ? response.data[0] : null;

  if (!ticket) {
    return { ticket, review: null };
  }

  const { reviews } = await getEntityReview({ entityId: ticket.id, entityType: 'ticket' });
  const ticketReviews = reviews.filter((x) => x.type === 'TICKET');

  return { ticket, reviews, ticketReviews };
}
